export default () => {
  const wrapper = document.getElementById('product-form-wrapper');
  const popup = document.getElementById('product-mobile-popup');
  const closeBtn = document.getElementById('product-mobile-popup-close');
  const openBtn = document.getElementById('product-mobile-popup-open');
  const OPENED = 'opened';

  const openPopup = () => {
    popup.classList.add(OPENED);
  };
  const closePopup = () => {
    popup.classList.remove(OPENED);
    wrapper.classList.remove('success');
  };

  openBtn.addEventListener('click', openPopup);
  closeBtn.addEventListener('click', closePopup);
}
